import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { ComponentPropType } from 'react-admin';
class ErrorBoundary extends Component {
    /* eslint-enable tree-shaking/no-side-effects-in-initialization */
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: undefined, errorInfo: undefined };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true, error, errorInfo });
    }
    render() {
        const { error: Error, children } = this.props;
        const { hasError, error, errorInfo } = this.state;
        return hasError && error
            ? createElement(Error, {
                error,
                errorInfo,
            })
            : children;
    }
}
/* eslint-disable tree-shaking/no-side-effects-in-initialization */
// eslint-disable-next-line react/static-property-placement
ErrorBoundary.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    error: ComponentPropType,
};
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map